module.exports = __webpack_public_path__ + "img/tb_2.5e8e1eb3.png";